import React from 'react';
import { styled } from 'baseui';
import { Spinner } from 'baseui/spinner';
import { LabelSmall } from 'baseui/typography';
import { VIDEO_OVERLAY_LAYER_Z_INDEX } from '../types';
const Container = styled<'div', {
  $direction: 'column' | 'row';
}>('div', ({
  $theme,
  $direction
}) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: VIDEO_OVERLAY_LAYER_Z_INDEX,
  display: 'flex',
  flexDirection: $direction,
  justifyContent: 'center',
  alignItems: 'center',
  gap: $theme.sizing.scale300,
  backgroundColor: $theme.name === 'light-theme' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(22, 22, 22, 0.5)'
}));
type PropsT = {
  message?: string;
  direction?: 'column' | 'row';
};
export function Loader({
  message,
  direction = 'column'
}: PropsT) {
  return <Container data-testid="video-loader" $direction={direction}>
      <Spinner />
      {message && <LabelSmall>{message}</LabelSmall>}
    </Container>;
}